import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";

import { ProductMetadataV2Wrapper, DividerStyled } from "./ProductMetadataV2LayoutComponents";

const ProductMetadataV2ItemIconSkeleton = styled(Skeleton)({
    borderRadius: 10,
});

function ProductMetadataV2ItemSkeleton() {
    return (
        <ItemWrapper>
            <ProductMetadataV2ItemIconSkeleton variant="rectangular" width={24} height={24} />
            <Skeleton variant="rectangular" width="50%" height={22} />
        </ItemWrapper>
    );
}

export function ProductMetadataV2Skeleton() {
    return (
        <ProductMetadataV2Wrapper>
            <ProductMetadataV2ItemSkeleton />
            <DividerStyled orientation="vertical" />
            <ProductMetadataV2ItemSkeleton />
            <DividerStyled orientation="vertical" />
            <ProductMetadataV2ItemSkeleton />
        </ProductMetadataV2Wrapper>
    );
}

const ItemWrapper = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    flex: 1,
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
}));
